// assets/people-directory.js

document.addEventListener('DOMContentLoaded', () => {

    const modal = document.getElementById('peopleModal');
    const filter = document.getElementById('country-filter');
    const focusFilter = document.getElementById('focus-filter');
    const gridCards = document.querySelectorAll('.person-card');

    // --- Filter Logic ---
    // if (filter) {
    //     filter.addEventListener('change', (event) => {
    //         const selectedHandle = event.target.value;
            
    //         gridCards.forEach(card => {
    //             const cardLocationHandle = card.getAttribute('data-location-handle');
                
    //             if (selectedHandle === 'all' || cardLocationHandle === selectedHandle) {
    //                 card.style.display = 'block';
    //             } else {
    //                 card.style.display = 'none';
    //             }
    //         });
    //     });
    // }

    // const focusFilter = document.getElementById('focus-filter');

    // if (focusFilter) {
    //     focusFilter.addEventListener('change', (event) => {
    //         const selectedFocus = event.target.value;

    //         gridCards.forEach(card => {
    //             const cardFocusHandles = card.getAttribute('data-focus-handles') || '';

    //             if (selectedFocus === 'all' || cardFocusHandles.includes(selectedFocus)) {
    //                 card.style.display = 'block';
    //             } else {
    //                 card.style.display = 'none';
    //             }
    //         });
    //     });
    // }

    function applyFilters() {
        const selectedCountry = filter ? filter.value : 'all';
        const selectedFocus = focusFilter ? focusFilter.value : 'all';

        gridCards.forEach(card => {
            const cardLocationHandle = card.getAttribute('data-location-handle');
            const cardFocusHandles = card.getAttribute('data-focus-handles') || '';

            const matchesCountry = (selectedCountry === 'all' || cardLocationHandle === selectedCountry);
            const matchesFocus = (selectedFocus === 'all' || cardFocusHandles.includes(selectedFocus));

            if (matchesCountry && matchesFocus) {
                card.style.display = 'block';
            } else {
                card.style.display = 'none';
            }
        });
    }

    if (filter) filter.addEventListener('change', applyFilters);
    if (focusFilter) focusFilter.addEventListener('change', applyFilters);


    // --- Modal Logic ---

    // Function to open the modal (called by the Liquid code's onclick)
    window.openPeopleModal = function(clickedButton) { // Renamed to 'clickedButton' for clarity
        
        // Find the parent article element that holds all the person's data
        const parentCard = clickedButton.closest('.person-card');
        if (!parentCard) return; // Exit if the parent card isn't found
        
        // --- Get Data from Button (from Liquid data- attributes) ---
        const name = clickedButton.getAttribute('data-title');
        const bio = clickedButton.getAttribute('data-bio');
        const credential = clickedButton.getAttribute('data-credential');
        const focusString = clickedButton.getAttribute('data-focus');
        const location = clickedButton.getAttribute('data-location');
        const language = clickedButton.getAttribute('data-language');
        const website = clickedButton.getAttribute('data-website');
        const linkedin = clickedButton.getAttribute('data-linkedin');
        const pageUrl = clickedButton.getAttribute('data-url');
        const available = clickedButton.getAttribute('data-available');
        
        // --- Populate Modal Content ---
        document.getElementById('modal-name').textContent = name;
        document.getElementById('modal-credential').textContent = credential;
        document.getElementById('modal-location').textContent = location;
        document.getElementById('modal-language').textContent = language;
        document.getElementById('modal-bio').textContent = bio;
        document.getElementById('available').textContent = available;

        // Contact Links
        const websiteLink = document.getElementById('modal-website');
        websiteLink.textContent = website;
        websiteLink.href = website.startsWith('http') ? website : ('http://' + website);
        
        const linkedinLink = document.getElementById('modal-linkedin');
        linkedinLink.href = linkedin; 
        
        // Link to full page
        document.getElementById('modal-link-to-page').href = pageUrl;

        
        // *************************************************************
        // *** FIX for Uncaught TypeError: can't access property "src" ***
        // *************************************************************
        const modalImage = document.getElementById('modal-image');
        const cardImage = parentCard.querySelector('.person-image-wrapper img');
        
        if (cardImage && modalImage) {
            // This is the correct, safe access path for the image source
            modalImage.src = cardImage.src; 
        } else if (modalImage) {
            // Fallback: Clear the image if it wasn't found (optional)
            modalImage.src = '';
        }
        
        // Focus List
        const focusList = document.getElementById('modal-focus-list');
        focusList.innerHTML = ''; // Clear previous items
        if (focusString) {
            const focusItems = focusString.split(',').map(item => item.trim());
            focusItems.forEach(item => {
                const li = document.createElement('li');
                li.textContent = item;
                focusList.appendChild(li);
            });
        }
        
        // --- Display Modal ---
        modal.style.display = 'block';
        document.body.style.overflow = 'hidden'; // Prevent scrolling the main page
    }

    // Function to close the modal
    window.closePeopleModal = function() {
        modal.style.display = 'none';
        document.body.style.overflow = ''; // Restore scrolling
    }
    
    // Close the modal if the user clicks anywhere outside of it
    window.onclick = function(event) {
        if (event.target === modal) {
            closePeopleModal();
        }
    }
});